// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dr-object {
  position: absolute;
  box-sizing: border-box;
  overflow: visible;
  -webkit-user-select: none;
          user-select: none;
}

.dr-object--selected {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.dr-text,
.dr-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  white-space: nowrap;
}

.dr-text-content,
.dr-tag-content {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dr-text-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.dr-image {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.dr-control-group {
  display: flex;
  gap: 6px;
  align-items: center;
}

.dr-control-btn {
  border: none;
  border-radius: 6px;
  padding: 4px 8px;
  color: #ffffff;
  cursor: pointer;
}

.dr-control-btn--green {
  background: #16a34a;
}

.dr-control-btn--red {
  background: #dc2626;
}

.dr-control-btn--blue {
  background: #2563eb;
  padding: 4px 10px;
}

.dr-control-input {
  width: 90px;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  box-sizing: border-box;
}

.dr-live-badge {
  font-size: 11px;
  color: #64748b;
}

.dr-tag--stale {
  background-image: none !important;
}

.dr-tag--stale .dr-tag-content {
  color: #701a2d;
  opacity: 1;
  text-shadow: 0 0 3px rgba(136, 19, 55, 0.1);
}

.dr-tag--stale .dr-control-input {
  border-color: rgba(136, 19, 55, 0.35);
  background: #faeef1;
  color: #701a2d;
  opacity: 1;
  cursor: not-allowed;
}

.dr-tag--stale .dr-control-btn:disabled {
  background: #e7bdc7;
  color: #701a2d;
  opacity: 1;
  cursor: not-allowed;
}

.dr-stale-badge {
  border: 1px solid rgba(136, 19, 55, 0.3);
  border-radius: 999px;
  padding: 1px 5px;
  color: #701a2d;
  background: rgba(255, 255, 255, 0.42);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.dr-handle {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #ffffff;
  border: 1px solid #2563eb;
  border-radius: 2px;
  box-sizing: border-box;
  z-index: 9999;
}

.dr-handle-n {
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.dr-handle-s {
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
}

.dr-handle-w {
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
}

.dr-handle-e {
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
}

.dr-handle-nw {
  top: -5px;
  left: -5px;
}

.dr-handle-ne {
  top: -5px;
  right: -5px;
}

.dr-handle-sw {
  bottom: -5px;
  left: -5px;
}

.dr-handle-se {
  bottom: -5px;
  right: -5px;
}
.dr-shape {
  display: block;
}

.dr-shape-inner {
  width: 100%;
  height: 100%;
}

.dr-shape-line {
  display: block;
}
.dr-shape-svg {
  display: block;
  width: 100%;
  height: 100%;
}
.dr-shape-custom-wrapper {
  width: 100%;
  height: 100%;
}

.dr-shape-svg {
  display: block;
  width: 100%;
  height: 100%;
}

.dr-shape-point {
  fill: #ffffff;
  stroke: #2563eb;
  stroke-width: 1.5;
  cursor: move;
}
.dr-shape-custom-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.dr-shape-svg {
  display: block;
  width: 100%;
  height: 100%;
}

.dr-shape-point {
  fill: #ffffff;
  stroke: #2563eb;
  stroke-width: 1.5;
  cursor: move;
}

.dr-shape-point--active {
  fill: #dbeafe;
  stroke: #1d4ed8;
  stroke-width: 2;
}

.dr-shape-segment-hit {
  stroke: transparent;
  stroke-width: 8;
  cursor: pointer;
}

.dr-shape-segment-hit--active {
  stroke: rgba(37, 99, 235, 0.18);
  stroke-width: 8;
}

.dr-shape-floating-action {
  position: absolute;
  top: -34px;
  left: 0;
  border: none;
  border-radius: 8px;
  padding: 6px 10px;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
  z-index: 20;
}

.dr-shape-floating-action--danger {
  background: #dc2626;
}
.dr-shape-floating-action--move {
  background: #0f766e;
  left: 0;
}

.dr-shape-floating-action--danger {
  left: 64px;
}

.dr-shape-floating-action--add {
  left: 170px;
}

.dr-quick-menu {
  position: absolute;
  z-index: 50;
}

.dr-quick-menu-trigger {
  width: 28px;
  height: 28px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #ffffff;
  color: #111827;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.dr-quick-menu-trigger:hover {
  background: #eff6ff;
  border-color: #93c5fd;
}

.dr-quick-menu-dropdown {
  position: absolute;
  top: 34px;
  right: 0;
  min-width: 150px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.14);
  padding: 6px;
  display: grid;
  gap: 4px;
}

.dr-quick-menu-item {
  border: none;
  background: #ffffff;
  color: #111827;
  text-align: left;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
}

.dr-quick-menu-item:hover {
  background: #f3f4f6;
}

.dr-quick-menu-item--danger {
  color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/components/designer/renderer/DesignerRenderer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".dr-object {\n  position: absolute;\n  box-sizing: border-box;\n  overflow: visible;\n  user-select: none;\n}\n\n.dr-object--selected {\n  outline: 2px solid #2563eb;\n  outline-offset: 2px;\n}\n\n.dr-text,\n.dr-tag {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 6px;\n  white-space: nowrap;\n}\n\n.dr-text-content,\n.dr-tag-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dr-text-content {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.dr-image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.dr-control-group {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.dr-control-btn {\n  border: none;\n  border-radius: 6px;\n  padding: 4px 8px;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.dr-control-btn--green {\n  background: #16a34a;\n}\n\n.dr-control-btn--red {\n  background: #dc2626;\n}\n\n.dr-control-btn--blue {\n  background: #2563eb;\n  padding: 4px 10px;\n}\n\n.dr-control-input {\n  width: 90px;\n  padding: 4px 6px;\n  border-radius: 6px;\n  border: 1px solid #cbd5e1;\n  box-sizing: border-box;\n}\n\n.dr-live-badge {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.dr-tag--stale {\n  background-image: none !important;\n}\n\n.dr-tag--stale .dr-tag-content {\n  color: #701a2d;\n  opacity: 1;\n  text-shadow: 0 0 3px rgba(136, 19, 55, 0.1);\n}\n\n.dr-tag--stale .dr-control-input {\n  border-color: rgba(136, 19, 55, 0.35);\n  background: #faeef1;\n  color: #701a2d;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.dr-tag--stale .dr-control-btn:disabled {\n  background: #e7bdc7;\n  color: #701a2d;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.dr-stale-badge {\n  border: 1px solid rgba(136, 19, 55, 0.3);\n  border-radius: 999px;\n  padding: 1px 5px;\n  color: #701a2d;\n  background: rgba(255, 255, 255, 0.42);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.dr-handle {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background: #ffffff;\n  border: 1px solid #2563eb;\n  border-radius: 2px;\n  box-sizing: border-box;\n  z-index: 9999;\n}\n\n.dr-handle-n {\n  top: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.dr-handle-s {\n  bottom: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.dr-handle-w {\n  left: -5px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.dr-handle-e {\n  right: -5px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.dr-handle-nw {\n  top: -5px;\n  left: -5px;\n}\n\n.dr-handle-ne {\n  top: -5px;\n  right: -5px;\n}\n\n.dr-handle-sw {\n  bottom: -5px;\n  left: -5px;\n}\n\n.dr-handle-se {\n  bottom: -5px;\n  right: -5px;\n}\n.dr-shape {\n  display: block;\n}\n\n.dr-shape-inner {\n  width: 100%;\n  height: 100%;\n}\n\n.dr-shape-line {\n  display: block;\n}\n.dr-shape-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.dr-shape-custom-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.dr-shape-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.dr-shape-point {\n  fill: #ffffff;\n  stroke: #2563eb;\n  stroke-width: 1.5;\n  cursor: move;\n}\n.dr-shape-custom-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.dr-shape-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.dr-shape-point {\n  fill: #ffffff;\n  stroke: #2563eb;\n  stroke-width: 1.5;\n  cursor: move;\n}\n\n.dr-shape-point--active {\n  fill: #dbeafe;\n  stroke: #1d4ed8;\n  stroke-width: 2;\n}\n\n.dr-shape-segment-hit {\n  stroke: transparent;\n  stroke-width: 8;\n  cursor: pointer;\n}\n\n.dr-shape-segment-hit--active {\n  stroke: rgba(37, 99, 235, 0.18);\n  stroke-width: 8;\n}\n\n.dr-shape-floating-action {\n  position: absolute;\n  top: -34px;\n  left: 0;\n  border: none;\n  border-radius: 8px;\n  padding: 6px 10px;\n  background: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 12px;\n  z-index: 20;\n}\n\n.dr-shape-floating-action--danger {\n  background: #dc2626;\n}\n.dr-shape-floating-action--move {\n  background: #0f766e;\n  left: 0;\n}\n\n.dr-shape-floating-action--danger {\n  left: 64px;\n}\n\n.dr-shape-floating-action--add {\n  left: 170px;\n}\n\n.dr-quick-menu {\n  position: absolute;\n  z-index: 50;\n}\n\n.dr-quick-menu-trigger {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #111827;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.dr-quick-menu-trigger:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.dr-quick-menu-dropdown {\n  position: absolute;\n  top: 34px;\n  right: 0;\n  min-width: 150px;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.14);\n  padding: 6px;\n  display: grid;\n  gap: 4px;\n}\n\n.dr-quick-menu-item {\n  border: none;\n  background: #ffffff;\n  color: #111827;\n  text-align: left;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.dr-quick-menu-item:hover {\n  background: #f3f4f6;\n}\n\n.dr-quick-menu-item--danger {\n  color: #dc2626;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
